import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-80f56a1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "liveListWrapper" };
const _hoisted_2 = { class: "flex tabs p-lr24 border-box font-32 gray-6 m-b20" };
const _hoisted_3 = { class: "noMore" };
import liveList from '@/components/list/liveList.vue';
import BetterScroll from '@/components/common/BetterScroll.vue';
import { ref, onMounted } from 'vue';
import { getLiveList } from '@/api/api';
import { getDepId } from '@/api/user';
import { getUserId } from '@/widget';
import { nextTick } from 'vue';
import Empty from '@/components/common/Empty.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const status = ref(1);
        const listBs = ref();
        const selectStatus = (s) => {
            status.value = s;
            getList(true);
            listBs.value.scrollTo(0, 0);
        };
        let depId = 1;
        const userId = getUserId();
        const getDep = () => {
            return new Promise((resolve, reject) => {
                if (!userId) {
                    depId = 1;
                    resolve(true);
                }
                getDepId(userId)
                    .then((res) => {
                    if (res.code == 200) {
                        resolve(true);
                        depId = res.data.depId;
                    }
                    else {
                        reject();
                    }
                })
                    .catch(() => {
                    reject();
                });
            });
        };
        const list = ref([]);
        const noMore = ref(false);
        const loaded = ref(false);
        let pageNo = 1;
        let loading = false;
        const getList = (bl) => {
            if (loading) {
                return;
            }
            if (bl) {
                pageNo = 1;
            }
            loaded.value = false;
            loading = true;
            getLiveList(userId, {
                departmentId: depId,
                pageNo,
                status: status.value
            }).then((res) => {
                loaded.value = true;
                if (res.code == 200) {
                    if (pageNo == 1) {
                        list.value = res.data.list;
                    }
                    else {
                        list.value = list.value.concat(res.data.list);
                    }
                    if (res.data.pageCount > pageNo) {
                        pageNo++;
                        noMore.value = false;
                    }
                    else {
                        noMore.value = true;
                    }
                }
                nextTick(() => {
                    loading = false;
                });
            });
        };
        // 预约成功
        const updateList = (ind) => {
            list.value[ind].subscribe = true;
        };
        onMounted(async () => {
            await getDep();
            getList();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["item", {
                                active: status.value == 1
                            }]),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (selectStatus(1)), ["stop"]))
                    }, " 直播预告 ", 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["item", {
                                active: status.value == 2
                            }]),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (selectStatus(2)), ["stop"]))
                    }, " 已结束 ", 2)
                ]),
                _createVNode(BetterScroll, {
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: true,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    noMore: noMore.value,
                    loaded: loaded.value,
                    onUpLoad: getList,
                    domStyle: {
                        position: 'relative',
                        width: '7.5rem',
                        height: `calc(100vh - 1.08rem)`
                    },
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                        listBs.value = _value;
                    }
                }, {
                    default: _withCtx(() => [
                        _createVNode(liveList, {
                            list: list.value,
                            onUpdateList: updateList
                        }, null, 8, ["list"]),
                        _withDirectives(_createVNode(Empty, null, null, 512), [
                            [_vShow, list.value.length == 0 && loaded.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_3, " 没有更多了 ", 512), [
                            [_vShow, noMore.value && loaded.value && list.value.length !== 0]
                        ])
                    ]),
                    _: 1
                }, 8, ["noMore", "loaded", "domStyle"])
            ]));
        };
    }
});
